
//俱乐部相关图片
export const ClubImageEnum = Object.freeze({
    CLUB_44: {
        VALUE: '44',
        LABEL: '俱乐部首页头部banner'
    },
    CLUB_45: {
        VALUE: '45',
        LABEL: '俱乐部首页头部-下方诚邀您的加盟四个图片'
    },
    CLUB_52: {
        VALUE: '52',
        LABEL: '6大扶持政策左侧图片'
    },
    CLUB_53: {
        VALUE: '53',
        LABEL: '6大扶持政策右侧图片'
    },
    CLUB_54: {
        VALUE: '54',
        LABEL: '6大扶持政策图片'
    },
    CLUB_55: {
        VALUE: '55',
        LABEL: '俱乐部首页-球馆设计'
    },
    CLUB_56: {
        VALUE: '56',
        LABEL: '俱乐部首页-关于我们图片'
    },
    CLUB_57: {
        VALUE: '57',
        LABEL: '俱乐部首页-战略合作伙伴'
    },
    CLUB_58: {
        VALUE: '58',
        LABEL: '俱乐部首页-招商合作'
    },
    CLUB_59: {
        VALUE: '59',
        LABEL: '俱乐部首页-加盟条件'
    },
    CLUB_60: {
        VALUE: '60',
        LABEL: '俱乐部首页-加盟流程'
    },
})